import * as Yup from 'yup';
import moment from 'moment';
import { TFunction } from 'i18next';
import { EMAIL_REGEX, isValidMobileNumber, extractNationalNumber } from 'utils';

const basicInformationSchema = (t: TFunction) =>
  Yup.object({
    firstName: Yup.string()
      .required(t('basicInformation.errors.firstNameRequired'))
      .trim(t('basicInformation.errors.firstNameRequired')),
    lastName: Yup.string()
      .required(t('basicInformation.errors.lastNameRequired'))
      .trim(t('basicInformation.errors.lastNameRequired')),
    email: Yup.string().matches(EMAIL_REGEX, {
      message: t('basicInformation.errors.invalidEmail'),
      excludeEmptyString: true,
    }),
    mobilePhoneNumber: Yup.string()
      .trim()
      .test('mobilePhoneNumber-valid', t('basicInformation.errors.invalidPhoneNumber'), function (value) {
        const nationalNumber = extractNationalNumber(value);
        if (!nationalNumber || nationalNumber.trim() === '') return true;
        return isValidMobileNumber(value);
      }),
    dateOfBirth: Yup.mixed()
      .nullable()
      .test('is-valid-date', t('basicInformation.errors.invalidDate'), value => {
        if (value) {
          if (moment.isMoment(value)) {
            return value.isValid();
          }
          if (typeof value === 'string' || value instanceof Date) {
            return moment(value).isValid();
          }
          return false;
        } else {
          return true;
        }
      }),
  });

export default basicInformationSchema;
